module.exports = __webpack_public_path__ + "static/media/5.f37968d9.jpg";